<template>
  <div>
    11
  </div>
</template>

<script>
export default {
  name: 'RewardSerialCollect'
}
</script>

<style scoped>

</style>
